<template>
  <div class="home">

  <section id="hero-home" class="hero has-text-centered is-dark hero-emphasis">
      <div class="hero-body">

      <h2 class="is-size-4">... the electric revolution is accelerating ... </h2><br/>
      <h3 class="is-size-2"> <strong>&gt; electrify.com &lt;</strong></h3>
      <h4 class="is-size-4">premium domain and brand <br/></h4>

      <div class="for-sale-banner">
        <h1 class="is-size-1" @click="openEnquiryForm">&gt; for sale &lt;</h1>
      </div>

      <!-- <strong>an unprecedented opportunity</strong> -->

      </div>
  </section>

  <video-background 
      src="https://avidofood.github.io/vue-responsive-video-background-player/demo/public/videos/roadster-loop-imperial.mp4"
      poster="/images/mainfoto.jpg"
      :sources="[
          {src: 'https://avidofood.github.io/vue-responsive-video-background-player/demo/public/videos/roadster-loop-imperial.mp4', res: 900, autoplay: true}, 
          {src: 'https://avidofood.github.io/vue-responsive-video-background-player/demo/public/videos/roadster-loop-imperial.mp4', res: 638, autoplay: true, poster: '<your-mobile-background-image-path>.png'}
      ]"
      style="max-height: 400px; height: 100vh;"
      overlay="linear-gradient(45deg,#2a4ae430,#fb949e6b)">


  </video-background>

  <!-- <section id="hero-billboard" class="hero has-text-centered is-dark hero-emphasis">

  </section> -->

    <div class="nav-footer">
        <br/>
        <b-button class="is-primary is-large buy-button" @click="openEnquiryForm">make offer</b-button>
        <div style="padding-top: 1em; text-align: center; color: white; font-style: italic;"><b>electrify:</b> to excite intensely or suddenly; to thrill.</div>
    </div>

    <b-modal :active.sync="isEnquiryModalActive" has-modal-card auto-focus custom-class="wide-modal">
      <EnquiryForm />
    </b-modal>

  </div>

</template>

<script>
import EnquiryForm from "./EnquiryForm.vue"

export default {
  components: {
    EnquiryForm
  },
  data() {
    return {
      isEnquiryModalActive: false,
    }
  },
  methods: {
    openEnquiryForm () {
      this.isEnquiryModalActive = true
    }
  }
}
</script>